


import React from "react";
import { useLanguage } from "../i18n/LanguageProvider";
import { DEFAULT_GAME_ID, GameService } from "../services/gameService";

export default function GamePage() {
  const { t } = useLanguage();
  const activeGame = GameService.get(DEFAULT_GAME_ID);

  return (
  <div
    style={{
      width: "92%",
      margin: "18px auto 0 auto",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
    }}
  >

  <div
  style={{
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.10)",
    borderRadius: "20px",
    padding: "18px 16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.22)",
  }}
>
 {/* Header Row (Titel + Status rechts) */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "10px",
  }}
>
  {/* Titel */}
  <div
    style={{
      fontSize: "22px",
      fontWeight: "800",
      color: "#fff",
    }}
  >
	    {activeGame.displayName}
  </div>

  {/* Status rechts oben */}
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "6px 12px",
      borderRadius: "999px",
      background: "rgba(40,180,90,0.16)",
      border: "1px solid rgba(40,180,90,0.35)",
      color: "#7CFF9D",
      fontWeight: "700",
      fontSize: "13px",
    }}
  >
    <span>✅</span>
    <span>{t("game.statusActive")}</span>
  </div>
</div>

  {/* Disclaimer im Container */}
  <div
    style={{
      color: "rgba(255,255,255,0.45)",
      fontSize: "12px",
      lineHeight: "1.4",
    }}
  >
    {t("game.disclaimer")}
  </div>
</div>

    {/* INFO TEXT */}
    <div
      style={{
        color: "rgba(255,255,255,0.85)",
        fontSize: "15px",
        lineHeight: "1.5",
        padding: "0 4px",
      }}
    >
      {t("game.moreGamesSoon")}
    </div>

    

  </div>
);
}
